<nb-card
  [nbSpinner]="isLoading"
  nbSpinnerSize="small"
  nbSpinnerStatus="primary"
>
  <nb-card-header>
    <div class="d-flex justify-content-between">
      <div class="title-page-wrapper">
        <span>Flow Reference</span
        ><nb-icon
          nbTooltip="Provides you with an overview of the main and sub flow from this flow."
          nbTooltipPlacement="right"
          nbTooltipTrigger="hover"
          nbTooltipStatus="basic"
          icon="question-mark-circle-outline"
        ></nb-icon>
      </div>
      <button
        (click)="dismiss()"
        type="button"
        class="btn-close"
        aria-label="Close"
      ></button></div
  ></nb-card-header>
  <nb-card-body style="padding-bottom: 0">
    <nb-accordion multi>
      <nb-accordion-item [expanded]="true">
        <nb-accordion-item-header>
          Parents
        </nb-accordion-item-header>
        <nb-accordion-item-body>
          <nb-list>
            <nb-list-item
              style="padding: 1.5rem"
              class="list-group-item-action justify-content-between align-items-center"
              *ngIf="
                !flowRelationshipsFilter || flowRelationshipsFilter.length == 0
              "
              >No main flow is using this flow.
            </nb-list-item>
            <nb-list-item
              style="padding: 0"
              class="list-group-item-action justify-content-between align-items-center"
              *ngIf="
                flowRelationshipsFilter && flowRelationshipsFilter.length >= 2
              "
            >
              <input
                style="background: white; border: 0"
                type="text"
                nbInput
                [(ngModel)]="searchText"
                fullWidth
                (keyup)="filterFlows()"
                placeholder="Search"
                fieldSize="small"
              />
            </nb-list-item>
            <nb-list-item
              (click)="clickedRow(item)"
              class="list-group-item-action justify-content-between align-items-center"
              *ngFor="let item of flowRelationships"
            >
              {{ item.name }}
              <nb-icon
                icon="external-link-outline"
                pack="eva"
                style="cursor: pointer; color: #8f9bb3; width: 15px"
                (click)="openFlow(item); $event.stopPropagation()"
              ></nb-icon>
            </nb-list-item>
          </nb-list>
        </nb-accordion-item-body>
      </nb-accordion-item>
      <nb-accordion-item [expanded]="true">
        <nb-accordion-item-header>
          Childs
        </nb-accordion-item-header>
        <nb-accordion-item-body>
          <nb-list>
            <nb-list-item
              style="padding: 1.5rem"
              class="list-group-item-action justify-content-between align-items-center"
              *ngIf="
                !subFlowRelationshipsFilter ||
                subFlowRelationshipsFilter.length == 0
              "
              >Sub flow not found in your flow.
            </nb-list-item>
            <nb-list-item
              style="padding: 0"
              class="list-group-item-action justify-content-between align-items-center"
              *ngIf="
                subFlowRelationshipsFilter &&
                subFlowRelationshipsFilter.length >= 2
              "
            >
              <input
                style="background: white; border: 0"
                type="text"
                nbInput
                [(ngModel)]="searchSubText"
                fullWidth
                (keyup)="filterSubFlows()"
                placeholder="Search"
                fieldSize="small"
              />
            </nb-list-item>
            <nb-list-item
              (click)="clickedRow(item)"
              class="list-group-item-action justify-content-between align-items-center"
              *ngFor="let item of subFlowRelationships"
            >
              {{ item.name }}
              <nb-icon
                icon="external-link-outline"
                pack="eva"
                style="cursor: pointer; color: #8f9bb3; width: 15px"
                (click)="openFlow(item); $event.stopPropagation()"
              ></nb-icon>
            </nb-list-item>
          </nb-list>
        </nb-accordion-item-body>
      </nb-accordion-item>
    </nb-accordion>
  </nb-card-body>
</nb-card>
